export const translations = {
  da: {
    "nav.home": "Forside",
    "nav.about": "Om os",
    "nav.services": "Ydelser",
    "nav.collaboration": "Samarbejde",
    "nav.contact": "Kontakt",
    "nav.phone": "Ring til os",
    "nav.mail": "Send en mail",
    "nav.address": "Adresse",
    "nav.hours": "Åbningstider",
    "nav.hours_val": "Man - Fre: 08:00 - 16:00",
    "nav.select_lang": "Vælg sprog",

    "hero.badge": "Professionel erhvervsrengøring & byggepladsservice",
    "hero.title1": "Erhvervsrengøring og byggepladsservice",
    "hero.title2": "med fokus på kvalitet og stabilitet",
    "hero.desc": "Vi leverer skræddersyede rengøringsløsninger til virksomheder, institutioner og byggepladser i hele Danmark. Altid med faste, uddannede medarbejdere og miljøvenlige produkter.",
    "hero.cta_contact": "Indhent gratis tilbud",
    "hero.cta_services": "Se vores ydelser",

    "municipal.title": "Vi leverer professionel erhvervsrengøring og byggepladsservice",

    "about.title": "Vi skaber sunde, rene og",
    "about.title_gold": "præsentable rammer",
    "about.title_end": "for jeres succes",
    "about.desc": "Med over 15 års erfaring i branchen har vi opbygget en dybdegående ekspertise inden for erhvervsrengøring og byggepladsservice. Vi forstår, at rene lokaler ikke kun handler om æstetik, men om sundhed, trivsel og det gode førstehåndsindtryk over for jeres kunder og medarbejdere.",
    "about.val1_title": "Uovertruffen Kvalitet",
    "about.val1_desc": "Vi går aldrig på kompromis med renligheden. Vores erfarne personale anvender de bedste metoder og produkter for at sikre et fejlfrit resultat hver gang.",
    "about.val2_title": "Ansvarlighed & Miljø",
    "about.val2_desc": "Vi tager ansvar for både vores medarbejdere og miljøet. Vi anvender skånsomme, svanemærkede rengøringsmidler og sikrer ordentlige arbejdsvilkår.",
    "about.val3_title": "Stabilitet & Tillid",
    "about.val3_desc": "En aftale er en aftale. Vi leverer stabil service til tiden, og I vil opleve faste, kendte ansigter, der kender jeres lokaler ud og ind.",
    "about.coverage_badge": "Geografisk dækning",
    "about.coverage_title": "Vi dækker hele Jylland, Fyn og Sjælland",
    "about.coverage_desc": "Uanset om jeres virksomhed er placeret i Fredericia, Aarhus, Odense, Esbjerg, Aalborg eller København, står Wecas ApS klar til at levere professionel rengøring. Med base i Fredericia har vi en central placering, der gør det nemt at servicere vores kunder hurtigt og effektivt.",
    "about.coverage_jylland": "Hele Jylland",
    "about.coverage_fyn": "Hele Fyn",
    "about.coverage_sjaelland": "Hele Sjælland",
    "about.coverage_central": "Centralt baseret",
    "about.stats_years": "Års erfaring",
    "about.stats_rate": "Kundetilfredshed",
    "about.stats_employees": "Glade medarbejdere",

    "services.title": "Professionelle rengøringsløsninger",
    "services.title_gold": "skræddersyet",
    "services.title_end": "til jeres behov",
    "services.desc": "Vi leverer alt fra daglig erhvervsrengøring til komplekse specialopgaver og byggepladsservice. Altid med fokus på kvalitet, ansvarlighed og stabilitet.",
    "services.read_more": "Læs mere om ydelsen",
    "services.all_services": "Se alle ydelser",

    "before_after.badge": "Visuel dokumentation",
    "before_after.title": "Før & Efter",
    "before_after.title_gold": "vores arbejde",
    "before_after.desc": "Billederne taler for sig selv. Se de markante resultater af vores professionelle dybderengøring, vinduespudsning og byggepladsservice.",
    "before_after.label_before": "FØR",
    "before_after.label_after": "EFTER",
    "before_after.slide1_title": "Dybdegående gulvbehandling",
    "before_after.slide1_desc": "Fjernelse af års slid, snavs og gammel voks efterfulgt af professionel forsegling.",
    "before_after.slide2_title": "Byggerengøring af badeværelse",
    "before_after.slide2_desc": "Fuldstændig fjernelse af cementrester, fugeslør og byggestøv inden aflevering.",
    "before_after.slide3_title": "Professionel vinduespudsning",
    "before_after.slide3_desc": "Fjernelse af fastgroet snavs og striber på store glaspartier med rentvandsanlæg.",

    "collaboration.badge": "Samarbejdsmodeller",
    "collaboration.title": "Hvordan vil I",
    "collaboration.title_gold": "samarbejde",
    "collaboration.title_end": "med os?",
    "collaboration.desc": "Vi tilbyder fleksible løsninger, der passer til jeres virksomheds behov. Vælg mellem et fast løbende samarbejde eller ad hoc-rengøring til enkeltstående opgaver.",
    "collaboration.model1_title": "Fast samarbejdspartner",
    "collaboration.model1_desc": "Få en fast, skræddersyet aftale, hvor vi varetager al jeres erhvervsrengøring og byggepladsservice løbende.",
    "collaboration.model1_li1": "Fast kontaktperson og faste rengøringsassistenter",
    "collaboration.model1_li2": "Skræddersyet rengøringsplan tilpasset jeres arbejdstider",
    "collaboration.model1_li3": "Løbende kvalitetssikring og tæt opfølgning",
    "collaboration.model1_li4": "Attraktive priser og prioriteret service ved akutte behov",
    "collaboration.model2_title": "Ad hoc & enkeltopgaver",
    "collaboration.model2_desc": "Har I brug for en enkeltstående dybdegående rengøring, flytterengøring eller hjælp i en spidsbelastning?",
    "collaboration.model2_li1": "Hurtig udrykning og fleksibel planlægning",
    "collaboration.model2_li2": "Ingen binding eller faste månedlige udgifter",
    "collaboration.model2_li3": "Perfekt til flytterengøring, hovedrengøring eller efter renovering",
    "collaboration.model2_li4": "Gennemskuelige priser baseret på opgavens omfang",
    "collaboration.cta": "Kontakt os for en uforpligtende snak",

    "testimonials.badge": "Kundeudtalelser",
    "testimonials.title": "Hvad siger",
    "testimonials.title_gold": "vores kunder",
    "testimonials.title_end": "om os?",
    "testimonials.desc": "Vores kunders tilfredshed er vores største succes. Læs et udvalg af udtalelser fra virksomheder, der samarbejder med Wecas ApS.",

    "contact.badge": "Kontakt os",
    "contact.title": "Lad os tage en",
    "contact.title_gold": "uforpligtende",
    "contact.title_end": "snak",
    "contact.desc": "Har I spørgsmål til vores ydelser, eller ønsker I et skræddersyet tilbud? Udfyld formularen, så vender vi tilbage inden for 24 timer.",
    "contact.info_title": "Vores kontaktoplysninger",
    "contact.info_desc": "I er altid velkomne til at ringe eller skrive til os direkte. Vi står klar til at hjælpe jer.",
    "contact.form_name": "Navn",
    "contact.form_email": "E-mail",
    "contact.form_phone": "Telefonnummer",
    "contact.form_company": "Virksomhed (valgfri)",
    "contact.form_service": "Ønsket ydelse",
    "contact.form_service_placeholder": "Vælg en ydelse...",
    "contact.form_message": "Besked",
    "contact.form_message_placeholder": "Beskriv jeres behov eller opgave...",
    "contact.form_submit": "Send besked",
    "contact.form_submitting": "Sender...",
    "contact.form_success": "Tak for din besked! Vi vender tilbage hurtigst muligt.",
    "contact.form_error": "Der skete en fejl. Prøv venligst igen eller ring til os.",
    "contact.qr_scan": "Scan QR-koden",
    "contact.insta_find": "Find os på Instagram under navnet Wecas ApS",
    "contact.fb_find": "Find os på Facebook under navnet Wecas ApS",
    "contact.scan_click": "Scan eller klik her",

    "footer.about": "Om Wecas ApS",
    "footer.about_desc": "Wecas ApS leverer professionel erhvervsrengøring og byggepladsservice af højeste kvalitet. Vi sikrer sunde, rene og præsentable rammer for jeres virksomhed.",
    "footer.links": "Hurtige links",
    "footer.services": "Vores ydelser",
    "footer.contact": "Kontakt os",
    "footer.rights": "Alle rettigheder forbeholdes.",

    "detail.back": "Tilbage til ydelser",
    "detail.category": "Kategori",
    "detail.get_offer": "Få et uforpligtende tilbud",
    "detail.get_offer_desc": "Udfyld formularen, så kontakter vi dig med et skræddersyet tilbud på denne ydelse.",
    "detail.faq_title": "Ofte stillede spørgsmål",
    "detail.faq_desc": "Her finder du svar på nogle af de mest almindelige spørgsmål om vores ydelser.",
    "detail.other_services": "Andre ydelser",
    "detail.other_services_desc": "Se vores øvrige professionelle rengøringsløsninger.",
    "detail.loading": "Indlæser ydelse...",
    "detail.not_found": "Ydelsen blev ikke fundet",
    "detail.not_found_desc": "Den søgte ydelse findes desværre ikke eller er blevet flyttet.",

    "coverage.badge": "Dækningsområde",
    "coverage.title": "Hvor leverer vi",
    "coverage.title_gold": "erhvervsrengøring og byggepladsservice",
    "coverage.title_end": "?",
    "coverage.desc": "Vi leverer professionel erhvervsrengøring og byggepladsservice i hele det østjyske vækstbælte, Trekantområdet, Fyn og Sjælland. Klik på byerne på kortet for at se vores lokale dækning.",
    "coverage.fredericia_desc": "Vores hovedkontor og base. Vi leverer lynhurtig og stabil service til virksomheder i hele Fredericia og omegn.",
    "coverage.vejle_desc": "Vi servicerer en lang række kontorer, klinikker og butikker i Vejle, herunder også i de kuperede erhvervsområder.",
    "coverage.kolding_desc": "Fra logistikvirksomheder til kontordomiciler – vi dækker hele Kolding med professionel erhvervsrengøring.",
    "coverage.horsens_desc": "Vi leverer stabil rengøring til både produktionsvirksomheder og liberale erhverv i Horsens og omegn.",
    "coverage.aarhus_desc": "I Danmarks næststørste by leverer vi skræddersyede rengøringsløsninger til både store domiciler og mindre kontorer.",
    "coverage.odense_desc": "Vi leverer stabil erhvervsrengøring og byggepladsservice til både mindre kontorer og store produktionsvirksomheder.",
    "coverage.kobenhavn_desc": "Vi dækker Storkøbenhavn og Sjælland med professionel erhvervsrengøring, byggepladsservice og specialrengøring.",
    "coverage.outside_title": "Har du brug for erhvervsrengøring eller byggepladsservice uden for disse områder?",
    "coverage.outside_desc": "Selvom dit postnummer ikke er markeret på kortet, kan vi ofte hjælpe alligevel ved større opgaver eller faste aftaler. Ring til os på 71 74 75 79 og lad os finde en løsning.",
    "coverage.outside_cta": "Ring og hør nærmere"
  },
  en: {
    "nav.home": "Home",
    "nav.about": "About us",
    "nav.services": "Services",
    "nav.collaboration": "Collaboration",
    "nav.contact": "Contact",
    "nav.phone": "Call us",
    "nav.mail": "Send an email",
    "nav.address": "Address",
    "nav.hours": "Opening hours",
    "nav.hours_val": "Mon - Fri: 08:00 - 16:00",
    "nav.select_lang": "Select language",

    "hero.badge": "Professional commercial cleaning & construction site service",
    "hero.title1": "Commercial cleaning and construction site service",
    "hero.title2": "with focus on quality and stability",
    "hero.desc": "We deliver tailored cleaning solutions for businesses, institutions, and construction sites throughout Denmark. Always with permanent, trained staff and eco-friendly products.",
    "hero.cta_contact": "Get a free quote",
    "hero.cta_services": "See our services",

    "municipal.title": "We deliver professional commercial cleaning and construction site service",

    "about.title": "We create healthy, clean and",
    "about.title_gold": "presentable environments",
    "about.title_end": "for your success",
    "about.desc": "With over 15 years of experience in the industry, we have built deep expertise in commercial cleaning and construction site services. We understand that clean premises are not just about aesthetics, but about health, well-being, and making a great first impression on your clients and employees.",
    "about.val1_title": "Unmatched Quality",
    "about.val1_desc": "We never compromise on cleanliness. Our experienced staff uses the best methods and products to ensure a flawless result every single time.",
    "about.val2_title": "Responsibility & Environment",
    "about.val2_desc": "We take responsibility for both our employees and the environment. We use gentle, Nordic Swan Ecolabelled cleaning agents and ensure fair working conditions.",
    "about.val3_title": "Stability & Trust",
    "about.val3_desc": "An agreement is an agreement. We deliver stable service on time, and you will experience permanent, familiar faces who know your premises inside out.",
    "about.coverage_badge": "Geographical coverage",
    "about.coverage_title": "We cover all of Jutland, Funen, and Zealand",
    "about.coverage_desc": "Whether your business is located in Fredericia, Aarhus, Odense, Esbjerg, Aalborg, or Copenhagen, Wecas ApS is ready to deliver professional cleaning. Based in Fredericia, we have a central location that makes it easy to service our customers quickly and efficiently.",
    "about.coverage_jylland": "All of Jutland",
    "about.coverage_fyn": "All of Funen",
    "about.coverage_sjaelland": "All of Zealand",
    "about.coverage_central": "Centrally based",
    "about.stats_years": "Years of experience",
    "about.stats_rate": "Customer satisfaction",
    "about.stats_employees": "Happy employees",

    "services.title": "Professional cleaning solutions",
    "services.title_gold": "tailored",
    "services.title_end": "to your needs",
    "services.desc": "We deliver everything from daily commercial cleaning to complex specialty tasks and construction site services. Always with a focus on quality, responsibility, and stability.",
    "services.read_more": "Read more about service",
    "services.all_services": "See all services",

    "before_after.badge": "Visual documentation",
    "before_after.title": "Before & After",
    "before_after.title_gold": "our work",
    "before_after.desc": "The pictures speak for themselves. See the significant results of our professional deep cleaning, window cleaning, and construction site services.",
    "before_after.label_before": "BEFORE",
    "before_after.label_after": "AFTER",
    "before_after.slide1_title": "Deep floor treatment",
    "before_after.slide1_desc": "Removal of years of wear, dirt, and old wax followed by professional sealing.",
    "before_after.slide2_title": "Construction cleaning of bathroom",
    "before_after.slide2_desc": "Complete removal of cement residue, grout haze, and construction dust before handover.",
    "before_after.slide3_title": "Professional window cleaning",
    "before_after.slide3_desc": "Removal of stubborn dirt and streaks on large glass sections using pure water systems.",

    "collaboration.badge": "Collaboration models",
    "collaboration.title": "How would you like to",
    "collaboration.title_gold": "collaborate",
    "collaboration.title_end": "with us?",
    "collaboration.desc": "We offer flexible solutions that fit your company's needs. Choose between a permanent ongoing collaboration or ad hoc cleaning for individual tasks.",
    "collaboration.model1_title": "Permanent partner",
    "collaboration.model1_desc": "Get a permanent, tailored agreement where we handle all your commercial cleaning and construction site services on an ongoing basis.",
    "collaboration.model1_li1": "Dedicated contact person and permanent cleaning assistants",
    "collaboration.model1_li2": "Tailored cleaning plan adapted to your working hours",
    "collaboration.model1_li3": "Ongoing quality assurance and close follow-up",
    "collaboration.model1_li4": "Attractive rates and prioritized service for urgent needs",
    "collaboration.model2_title": "Ad hoc & single tasks",
    "collaboration.model2_desc": "Do you need a one-off deep cleaning, move-out cleaning, or extra help during a peak period?",
    "collaboration.model2_li1": "Fast response and flexible scheduling",
    "collaboration.model2_li2": "No binding contract or fixed monthly expenses",
    "collaboration.model2_li3": "Perfect for move-out cleaning, deep cleaning, or post-renovation",
    "collaboration.model2_li4": "Transparent pricing based on the scope of the task",
    "collaboration.cta": "Contact us for a non-binding talk",

    "testimonials.badge": "Testimonials",
    "testimonials.title": "What do",
    "testimonials.title_gold": "our clients",
    "testimonials.title_end": "say about us?",
    "testimonials.desc": "Our customers' satisfaction is our greatest success. Read a selection of testimonials from companies that collaborate with Wecas ApS.",

    "contact.badge": "Contact us",
    "contact.title": "Let's have a",
    "contact.title_gold": "non-binding",
    "contact.title_end": "talk",
    "contact.desc": "Do you have questions about our services, or would you like a tailored quote? Fill out the form, and we will get back to you within 24 hours.",
    "contact.info_title": "Our contact info",
    "contact.info_desc": "You are always welcome to call or write to us directly. We are ready to help you.",
    "contact.form_name": "Name",
    "contact.form_email": "Email",
    "contact.form_phone": "Phone number",
    "contact.form_company": "Company (optional)",
    "contact.form_service": "Desired service",
    "contact.form_service_placeholder": "Select a service...",
    "contact.form_message": "Message",
    "contact.form_message_placeholder": "Describe your needs or task...",
    "contact.form_submit": "Send message",
    "contact.form_submitting": "Sending...",
    "contact.form_success": "Thank you for your message! We will get back to you as soon as possible.",
    "contact.form_error": "An error occurred. Please try again or call us.",
    "contact.qr_scan": "Scan the QR code",
    "contact.insta_find": "Find us on Instagram under the name Wecas ApS",
    "contact.fb_find": "Find us on Facebook under the name Wecas ApS",
    "contact.scan_click": "Scan or click here",

    "footer.about": "About Wecas ApS",
    "footer.about_desc": "Wecas ApS delivers professional commercial cleaning and construction site services of the highest quality. We ensure healthy, clean, and presentable environments for your business.",
    "footer.links": "Quick links",
    "footer.services": "Our services",
    "footer.contact": "Contact us",
    "footer.rights": "All rights reserved.",

    "detail.back": "Back to services",
    "detail.category": "Category",
    "detail.get_offer": "Get a non-binding quote",
    "detail.get_offer_desc": "Fill out the form, and we will contact you with a tailored quote for this service.",
    "detail.faq_title": "Frequently asked questions",
    "detail.faq_desc": "Here you will find answers to some of the most common questions about our services.",
    "detail.other_services": "Other services",
    "detail.other_services_desc": "See our other professional cleaning solutions.",
    "detail.loading": "Loading service...",
    "detail.not_found": "Service not found",
    "detail.not_found_desc": "The requested service was not found or has been moved.",

    "coverage.badge": "Coverage area",
    "coverage.title": "Where do we deliver",
    "coverage.title_gold": "commercial cleaning and construction site service",
    "coverage.title_end": "?",
    "coverage.desc": "We deliver professional commercial cleaning and construction site services throughout the East Jutland growth belt, the Triangle Area, Funen, and Zealand. Click on the cities on the map to see our local coverage.",
    "coverage.fredericia_desc": "Our headquarters and base. We deliver lightning-fast and stable service to businesses throughout Fredericia and the surrounding area.",
    "coverage.vejle_desc": "We service a wide range of offices, clinics, and shops in Vejle, including in the hilly business districts.",
    "coverage.kolding_desc": "From logistics companies to office domiciles – we cover all of Kolding with professional commercial cleaning.",
    "coverage.horsens_desc": "We deliver stable cleaning to both production companies and liberal professions in Horsens and the surrounding area.",
    "coverage.aarhus_desc": "In Denmark's second-largest city, we deliver tailored cleaning solutions to both large domiciles and smaller offices.",
    "coverage.odense_desc": "We deliver stable commercial cleaning and construction site services to both smaller offices and large production companies.",
    "coverage.kobenhavn_desc": "We cover Greater Copenhagen and Zealand with professional commercial cleaning, construction site services, and specialty cleaning.",
    "coverage.outside_title": "Do you need commercial cleaning or construction site service outside these areas?",
    "coverage.outside_desc": "Even if your zip code is not marked on the map, we can often help anyway for larger tasks or permanent agreements. Call us at 71 74 75 79 and let's find a solution.",
    "coverage.outside_cta": "Call to learn more"
  }
}

export const DA_TO_EN_SLUGS = {
  'professionel-erhvervsrengoering': 'professional-commercial-cleaning',
  'professionel-kontorrengoering': 'professional-office-cleaning',
  'hygiejnisk-klinikrengoering': 'hygienic-clinic-cleaning',
  'hospitaler-og-institutioner-rengoering': 'hospital-and-institution-cleaning',
  'skole-og-institutionsrengoering': 'school-and-institution-cleaning',
  'professionel-rengoering-af-dyreklinikker': 'professional-veterinary-clinic-cleaning',
  'rengoering-af-saloner-og-skonhedsklinikker': 'salon-and-beauty-clinic-cleaning',
  'svoemmehal-og-sportsrengoering': 'swimming-pool-and-sports-cleaning',
  'bank-og-finansrengoering': 'bank-and-financial-cleaning',
  'erhvervs-vinduespudsning': 'commercial-window-cleaning',
  'skraeddersyet-specialrengoering': 'tailored-specialty-cleaning',
  'grundig-flytterengoering': 'thorough-move-out-cleaning',
  'professionel-sommerhusrengoering': 'professional-holiday-home-cleaning',
  'professionel-vinduespudsning': 'professional-window-cleaning',
  'effektiv-byggepladsservice': 'effective-construction-site-service',
  'oprydning-af-byggepladser': 'construction-site-cleanup',
  'skurevognrengoering': 'construction-trailer-cleaning'
}

export const EN_TO_DA_SLUGS = {
  'professional-commercial-cleaning': 'professionel-erhvervsrengoering',
  'professional-office-cleaning': 'professionel-kontorrengoering',
  'hygienic-clinic-cleaning': 'hygiejnisk-klinikrengoering',
  'hospital-and-institution-cleaning': 'hospitaler-og-institutioner-rengoering',
  'school-and-institution-cleaning': 'skole-og-institutionsrengoering',
  'professional-veterinary-clinic-cleaning': 'professionel-rengoering-af-dyreklinikker',
  'salon-and-beauty-clinic-cleaning': 'rengoering-af-saloner-og-skonhedsklinikker',
  'swimming-pool-and-sports-cleaning': 'svoemmehal-og-sportsrengoering',
  'bank-and-financial-cleaning': 'bank-og-finansrengoering',
  'commercial-window-cleaning': 'erhvervs-vinduespudsning',
  'tailored-specialty-cleaning': 'skraeddersyet-specialrengoering',
  'thorough-move-out-cleaning': 'grundig-flytterengoering',
  'professional-holiday-home-cleaning': 'professionel-sommerhusrengoering',
  'professional-window-cleaning': 'professionel-vinduespudsning',
  'effective-construction-site-service': 'effektiv-byggepladsservice',
  'construction-site-cleanup': 'oprydning-af-byggepladser',
  'construction-trailer-cleaning': 'skurevognrengoering'
}

export const SLUG_MAP = {
  ...DA_TO_EN_SLUGS,
  ...EN_TO_DA_SLUGS
}

